import React from 'react';
import logoPE from '../images/logo-ft-horizontal.svg';
import './Propulsed.scss';

export default function Propulsed() {
    return (
        <div className="Propulsed">
            <img className="logo pl-1" src={logoPE} alt="France Travail"/>
        </div>
    );
}
